<template>
  <div>
    <div class="grid grid-cols-3 font-heiti text-sm">
      <div class="col-span-3">&nbsp;</div>
      <div class="col-span-2"></div>
      <div class="col-span-1 text-right">第 {{page}} 页（共 {{total}} 页）</div>
    </div>
  </div>
</template>

<script>
// 页脚
export default {
  props: ['info', 'page', 'total']
}
</script>
